import cn from 'clsx';
import React from 'react';

import styles from './Stepper.module.scss';

interface StepperProps {
  currentStep: number;
  steps: string[];
}

export const Stepper = ({ currentStep, steps }: StepperProps) => {
  return (
    <div className={styles.stepper}>
      {steps?.map((step, index) => {
        const stepParts = step.split('\n');

        return (
          <div
            key={step.trim()}
            className={cn(styles['stepper__item'], {
              [styles['stepper__item--active']]: index <= currentStep,
              [styles['stepper__item--completed']]: index < currentStep,
            })}
          >
            <div
              className={cn(styles['stepper__counter'], {
                [styles['stepper__counter--active']]: index <= currentStep,
                [styles['stepper__counter--completed']]: index < currentStep,
              })}
            />
            <div
              className={cn(styles['stepper__title'], {
                [styles['stepper__title--active']]: index <= currentStep,
              })}
            >
              {stepParts.map((part) => (
                <div key={part.trim()}>{part}</div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};
